import { create } from 'zustand';

const useClusterZoneStore = create((set) => ({
  clusterzone: {},

  setClusterZone: (newClusterZone) => set({ clusterzone: newClusterZone }),

  clearClusterZone: () => set({ clusterzone: {} }),
}));

export default useClusterZoneStore;
